import { render, staticRenderFns } from "./filterTag.vue?vue&type=template&id=1646c32c&scoped=true&"
import script from "./filterTag.vue?vue&type=script&lang=js&"
export * from "./filterTag.vue?vue&type=script&lang=js&"
import style0 from "./filterTag.vue?vue&type=style&index=0&id=1646c32c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1646c32c",
  null
  
)

export default component.exports